export default __webpack_public_path__ + "static/media/line.65f2fef8.svg";